import React from 'react';
import styled from 'styled-components';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { IconContext } from 'react-icons';
import { Palette } from 'core/config';

interface Props 
{
    content?     : string;
    step?        : string;
    css?         : string;
    headerCss?   : string;
    backText?    : string;
    backHandler? : () => void;
}

export const CardHeader : React.FunctionComponent<Props> = ({ 
    content='', 
    step, 
    css, 
    headerCss, 
    backText='', 
    backHandler, 
    children
}) =>
{
    return (
        <Container css={css}>
            <NavHeader>
                {step && (
                    <>
                        <NavBack>
                            {backHandler && (
                                <BackText onClick={backHandler} hasBackText={backText !== ''}>
                                    <IconContext.Provider value={{ size: '1.3em' }}>
                                        <BackArrow />
                                    </IconContext.Provider>
                                    {backText ? backText : 'Back'}
                                </BackText>
                            )}
                        </NavBack>
                        <NavCounter>{step}</NavCounter>
                    </>
                )}
            </NavHeader>
            <MainHeader css={headerCss}>
                {content}
                {children}
            </MainHeader>
        </Container>
    );
};

type CSS = {
    css? : string;
};

const Container = styled.div<CSS>`
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-bottom: 13px;
    margin-top: -5px;

    ${props => props.css && props.css};
`;

const MainHeader = styled.div<CSS>`
    color: ${Palette.BLUE};
    text-align: left;
    font: normal normal normal 27px 'SofiaPro-Bold';
    font-weight: 500;
    padding-left: 60px;
    padding-right: 60px;
    margin-top: -5px;
    line-height: 28px;

    ${props => props.css && props.css}
`;

const NavHeader = styled.div`
    display: flex;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 39px;
    padding-top: 39px;
`;

const NavBack = styled.div`
    flex-grow: 1;
    margin-left: -10px;
`;

const NavCounter = styled.div`
    display: flex;
    align-items: center;
    color: ${Palette.BLUE};
    font: normal normal normal 14px 'SofiaPro-Regular';

`;

type HasBackText = {
    hasBackText : boolean;
};

// const BackArrow = styled(IoIosArrowRoundBack)<HasBackText>`
//     padding-right: 10px;
//     padding-top: 3px;
//     min-width: 20px;

//     ${props => props.hasBackText ? 'padding-left: 40px;' : '' }
// `;

const BackArrow = styled(IoIosArrowRoundBack)`
    padding-right: 10px;
    padding-top: 3px;
    min-width: 20px;
`;

const BackText = styled.div<HasBackText>`
    width: 75px;
    color: ${Palette.BLUE};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font: normal normal normal 14px 'SofiaPro-Regular';
    white-space: nowrap;

    ${props => props.hasBackText ? 'padding-left: 20px !important;' : ''}

    &:hover ${BackArrow} {}
`;